import { render } from "./Expenses.vue?vue&type=template&id=7f941da5&scoped=true"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"

import "./Expenses.vue?vue&type=style&index=0&id=7f941da5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f941da5"]])

export default __exports__